import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import { Container, Row, Col } from 'react-bootstrap'
import Dashboard from '../pages/admin/Dashboard'
import Businesses from '../pages/admin/businesses/Businesses'
import Parameters from '../pages/admin/parameters/Parameter'
import AnalisysTypes from '../pages/admin/analisysTypes/AnalisysTypes'
import WorkOrders from '../pages/admin/workOrders/WorkOrders'
import Operators from '../pages/admin/operators/Operators'
import Movements from '../pages/admin/movements/Movements'
import Balance from '../pages/admin/balances/Balance'
import Logs from '../pages/admin/Logs'
import Bills from '../pages/admin/bills/Bills'
import Users from '../pages/admin/users/Users'
import Version from '../version'
import Menu from '../components/menus/Menu'
import Budget from '../pages/admin/budget/Budget'

export default function AdminRouter() {
	return (
		<Container fluid className='contenido p-0'>
			<Menu />
			<Routes>
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/providers" element={<Businesses typeBusiness="provider" />} />
				<Route path="/clients" element={<Businesses typeBusiness="client" />} />
				<Route path="/analisystypes" element={<AnalisysTypes />} />
				<Route path="/budgets" element={<Budget userType="Admin" />} />
				<Route path="/workorders" element={<WorkOrders userType="Admin" />} />
				<Route path="/operators" element={<Operators />} />
				<Route path="/parameters" element={<Parameters />} />
				<Route path="/movements" element={<Movements />} />
				<Route path="/balance" element={<Balance />} />
				<Route path="/bills" element={<Bills typeBill="bill" />} />
				<Route path="/autobills" element={<Bills typeBill="autobill" />} />
				<Route path="/proformas" element={<Bills typeBill="proforma" />} />
				<Route path="/users" element={<Users />} />
				<Route path="/logs" element={<Logs />} />
				<Route path="*" element={<NotFoundPage />} />
			</Routes>
			<Row>
				<Col className='text-center my-3'>
					<Version />
				</Col>
			</Row>
		</Container>
	)
}